/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import * as consts from '../../const.js';
import DocumentsService from '../documents/documents.service';
import React from 'react';

const toLowerCase = (str) => (str && typeof str === 'string' ? str.toLowerCase() : '');

export default class NotesService {
  static columnNames = [
    { key: 'documentName', name: consts.DOCUMENT_NAME },
    { key: 'timestamp', name: consts.TIMESTAMP },
    { key: 'reporter', name: consts.REPORTER },
    { key: 'sectionId', name: consts.SECTION_ID },
    { key: 'subject', name: consts.NOTE_SUBJECT },
    { key: 'note', name: consts.NOTE }
  ];

  static processRows(props, documentNameFilter) {
    let rows = [];
    const { notesData, timezone } = props;
    for (let note of notesData.notes.data) {
      let documentFullName = DocumentsService.buildDocumentFullName(note.documentName, note.documentVersion);
      if (!documentNameFilter || documentFullName === documentNameFilter) {
        for (let rep of notesData.users) {
          if (toLowerCase(rep.email) === toLowerCase(note.reporterEmail)) {
            rows.push({
              documentName: documentFullName,
              timestamp: note.timestamp,
              timezone,
              reporter: rep.lastName + ', ' + rep.firstName,
              sectionId: note.sectionId,
              subject: note.subject,
              body: note.note,
              type: note.type
            });
            break;
          }
        }
      }
    }
    return rows;
  }
}
